import { TIPTAP_POLL_TYPE } from 'ricos-content';
import pollDataDefaults from 'ricos-schema/dist/statics/poll.defaults.json';
import { Poll } from './component.js';
import 'react';
import '../viewer/poll-viewer.js';
import 'ricos-context';
import 'wix-rich-content-editor-common/libs/EditorEventsContext';
import '../components/rce-helpers-context/index.js';
import 'prop-types';
import '../viewer/poll-component.js';
import 'classnames';
import 'react-flip-move';
import 'react-measure';
import '../style-inject.es-746bb8ed.js';
import '../components/poll-option/index.js';
import '../defaults-0542c304.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../components/poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../dataHooks.js';
import '../RemoveOption-0fb59667.js';
import '../assets/icons/RemoveIcon.js';
import '../components/poll-option/PollOptionBase.js';
import '../components/poll-option/types.js';
import '../components/poll-context/types.js';
import '../assets/icons/NonEditableIcon.js';
import '../assets/icons/CheckIcon.js';
import '../components/image-upload/ImageUpload.js';
import '../components/image-upload/types.js';
import '../assets/icons/LoaderIcon.js';
import '../assets/icons/ReplaceIcon.js';
import '../components/text-field/TextField.js';
import 'lodash';
import '../components/poll-option/PollListOption.js';
import '../components/poll-option/webview/PollListOptionWebview.js';
import '../option-webview-c29b68a5.js';
import '../components/poll-option/webview/PollGridOptionWebview.js';
import '../components/poll-header/PollHeader.js';
import '../components/poll-context/PollContext.js';
import '../components/voted-users/VotedUsers.js';
import '../components/voted-users/types.js';
import 'react-modal';
import '../VotedUsersModal-b3691022.js';
import 'react-infinite-scroller';
import '../components/voted-users/VoterAvatar.js';
import 'wix-rich-content-ui-components';
import '../components/voted-users/FallbackAvatar.js';
import '../assets/icons/AddIcon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const name = TIPTAP_POLL_TYPE;
const tiptapExtensions = [
  {
    type: "node",
    name,
    groups: ["react"],
    reconfigure: (config, _extensions, _props, settings) => __spreadProps(__spreadValues({}, config), {
      addOptions: () => settings
    }),
    Component: Poll,
    createExtensionConfig() {
      return {
        name: this.name,
        atom: false,
        group: "block",
        addAttributes: () => __spreadProps(__spreadValues({}, pollDataDefaults), {
          loading: {
            default: false
          }
        }),
        addCommands() {
          return {};
        }
      };
    }
  }
];

export { tiptapExtensions };
//# sourceMappingURL=tiptap.js.map
